import React, { useEffect, useState } from 'react';
import GridInputs from '../../../components/common/inputs/GridInputs';
import axios from 'axios';
import { SubmitButton } from '../../../components/common/button/CustomButtons';
import useConfirm from '../../../components/common/useConfirm';
import GridDatePicker from '../../../components/common/inputs/GridDatePicker';
import { apiConstant, navigationConstant } from '../constant';
import moment from 'moment';
import AutocompleteGridmui from '../../../components/common/autocomplete/AutocompleteGridmui';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useQuery } from '../../../hooks/UseQuery';
import lodash from 'lodash';
import {
  Bending,
  Draw,
  Fixtures,
  Flatness,
  Piercing,
  Blank,
} from '../checklist/helpers/checklist';
import { useNavigate } from 'react-router-dom';

const selectChecklistPreventive = [
  'None',
  'Bending',
  'Draw',
  'Fixtures',
  'Flatness',
  'Piercing',
  'Blank',
];
const ModalInput = ({
  id,
  setIsModal,
  setListId,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
  setListId: any;
}) => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [render, setRender] = useState(false);
  const navigate = useNavigate();
  const [customer, setCustomer] = useState([]);
  const [checkMachine, setCheckMachine] = useState('None');
  // const history = useHistory();
  // const documentType = useQuery('documentType');
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update MTTR' : 'Create MTTR'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`
  );

  return (
    <>
      <FormControl
        style={{
          width: '500px',
          marginRight: '0.5rem',
          marginTop: '0.6rem',
          marginLeft: '0.6rem',
        }}
        variant="filled"
        className="select-field"
      >
        <InputLabel>Select Tool</InputLabel>
        <Select
          name="checkMachine"
          key={checkMachine}
          defaultValue={checkMachine}
          onChange={(e) => {
            setCheckMachine(e.target.value);
          }}
          className="spec-select-character"
        >
          {selectChecklistPreventive.map((machine: any, index: any) => {
            return (
              <MenuItem key={index} value={machine}>
                {machine.replace(/_/g, ' ')}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          // label={`${id ? 'update' : 'submit'}`}
          label="OK"
          type="button"
          //
          onClick={() => {
            navigate(
              `${navigationConstant.createChecklist}/${id}/${checkMachine}`
            );
          }}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default ModalInput;
